import React, { useState } from 'react';

function WhatsAppMessenger({ student, onClose }) {
  const [message, setMessage] = useState('');
  const [predefinedMessage, setPredefinedMessage] = useState('');

  const predefinedMessages = [
    'Hello! This is regarding your child\'s academic progress.',
    'Your child has been absent today. Please confirm if everything is okay.',
    'Congratulations! Your child performed excellently in today\'s test.',
    'Please ensure your child completes the homework assigned today.',
    'Parent-teacher meeting is scheduled. Please confirm your availability.',
    'Your child needs to improve attendance. Let\'s discuss this.',
    'Great improvement in your child\'s performance this week!',
    'Please send the required documents for your child.',
    'Your child forgot their books today. Please remind them.',
    'Excellent behavior shown by your child in class today!'
  ];

  const sendWhatsAppMessage = () => {
    const phoneNumber = student.guardianPhone || student.mobile || '';
    const finalMessage = message || predefinedMessage;
    
    if (!phoneNumber) {
      alert('No phone number available for this student');
      return;
    }

    if (!finalMessage.trim()) {
      alert('Please enter a message');
      return;
    }

    // Clean phone number (remove spaces, dashes, etc.)
    const cleanPhone = phoneNumber.replace(/[^\d+]/g, '');
    
    // Format for WhatsApp (remove + if present, add country code if needed)
    let formattedPhone = cleanPhone;
    if (formattedPhone.startsWith('+')) {
      formattedPhone = formattedPhone.substring(1);
    }
    
    // If phone doesn't start with country code, assume India (+91)
    if (formattedPhone.length === 10 && !formattedPhone.startsWith('91')) {
      formattedPhone = '91' + formattedPhone;
    }

    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodeURIComponent(finalMessage)}`;
    
    // Open WhatsApp
    window.open(whatsappUrl, '_blank');
    
    // Close the modal
    onClose();
  };

  return (
    <div className="mobile-popup-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '10px',
      overflowY: 'auto'
    }}>
      <div className="mobile-popup-content" style={{
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        borderRadius: '20px',
        padding: '20px',
        width: '100%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        border: '2px solid #e2e8f0',
        position: 'relative',
        margin: 'auto'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '25px',
          paddingBottom: '15px',
          borderBottom: '2px solid #e2e8f0'
        }}>
          <div>
            <h2 style={{
              margin: 0,
              color: '#25d366',
              fontSize: '24px',
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              📱 WhatsApp Message
            </h2>
            <p style={{
              margin: '5px 0 0 0',
              color: '#666',
              fontSize: '14px'
            }}>
              Send message to {student.name}'s parent
            </p>
          </div>
          <button
            onClick={onClose}
            className="mobile-popup-close"
            style={{
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: 'bold',
              boxShadow: '0 4px 15px rgba(239, 68, 68, 0.3)',
              transition: 'all 0.3s ease',
              position: 'absolute',
              top: '15px',
              right: '15px',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
        </div>

        {/* Student Info */}
        <div style={{
          background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
          padding: '15px',
          borderRadius: '12px',
          marginBottom: '20px',
          border: '1px solid #22c55e'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <p style={{ margin: '0 0 5px 0', color: '#16a34a', fontSize: '16px', fontWeight: '600' }}>
                👤 {student.name} - Class {student.class}
              </p>
              <p style={{ margin: 0, color: '#15803d', fontSize: '14px' }}>
                📞 {student.guardianPhone || student.mobile || 'No phone number'}
              </p>
            </div>
            <div style={{
              background: '#25d366',
              color: 'white',
              padding: '8px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              WhatsApp Ready
            </div>
          </div>
        </div>

        {/* Quick Message Templates */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            marginBottom: '10px',
            color: '#374151',
            fontSize: '14px',
            fontWeight: '600'
          }}>
            📝 Quick Message Templates:
          </label>
          <select
            value={predefinedMessage}
            onChange={(e) => {
              setPredefinedMessage(e.target.value);
              setMessage(''); // Clear custom message when template is selected
            }}
            style={{
              width: '100%',
              padding: '12px',
              border: '2px solid #e5e7eb',
              borderRadius: '10px',
              fontSize: '14px',
              background: '#f9fafb',
              transition: 'all 0.3s ease',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = '#25d366'}
            onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
          >
            <option value="">Select a template message...</option>
            {predefinedMessages.map((msg, index) => (
              <option key={index} value={msg}>
                {msg.substring(0, 50)}...
              </option>
            ))}
          </select>
        </div>

        {/* Custom Message */}
        <div style={{ marginBottom: '25px' }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: '#374151',
            fontSize: '14px',
            fontWeight: '600'
          }}>
            ✏️ Or write your custom message:
          </label>
          <textarea
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              setPredefinedMessage(''); // Clear template when custom message is typed
            }}
            placeholder="Type your message here..."
            rows={4}
            style={{
              width: '100%',
              padding: '12px',
              border: '2px solid #e5e7eb',
              borderRadius: '10px',
              fontSize: '14px',
              background: '#f9fafb',
              transition: 'all 0.3s ease',
              resize: 'vertical',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = '#25d366'}
            onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
          />
        </div>

        {/* Message Preview */}
        {(message || predefinedMessage) && (
          <div style={{
            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
            padding: '15px',
            borderRadius: '12px',
            marginBottom: '20px',
            border: '1px solid #3b82f6'
          }}>
            <p style={{
              margin: '0 0 8px 0',
              color: '#1e40af',
              fontSize: '14px',
              fontWeight: '600'
            }}>
              📋 Message Preview:
            </p>
            <p style={{
              margin: 0,
              color: '#1e40af',
              fontSize: '14px',
              fontStyle: 'italic',
              lineHeight: '1.4'
            }}>
              "{message || predefinedMessage}"
            </p>
          </div>
        )}

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: '15px',
          justifyContent: 'center'
        }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '10px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              boxShadow: '0 4px 15px rgba(107, 114, 128, 0.3)',
              transition: 'all 0.3s ease',
              minWidth: '100px'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            Cancel
          </button>
          <button
            onClick={sendWhatsAppMessage}
            disabled={!student.guardianPhone && !student.mobile}
            style={{
              background: (student.guardianPhone || student.mobile)
                ? 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)'
                : 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '10px',
              cursor: (student.guardianPhone || student.mobile) ? 'pointer' : 'not-allowed',
              fontSize: '14px',
              fontWeight: '600',
              boxShadow: (student.guardianPhone || student.mobile)
                ? '0 4px 15px rgba(37, 211, 102, 0.3)'
                : '0 4px 15px rgba(156, 163, 175, 0.3)',
              transition: 'all 0.3s ease',
              minWidth: '140px'
            }}
            onMouseOver={(e) => {
              if (student.guardianPhone || student.mobile) {
                e.target.style.transform = 'translateY(-2px)';
              }
            }}
            onMouseOut={(e) => {
              if (student.guardianPhone || student.mobile) {
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            📱 Send WhatsApp
          </button>
        </div>

        {/* Info Note */}
        <div style={{
          marginTop: '20px',
          padding: '15px',
          background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
          borderRadius: '10px',
          border: '1px solid #f59e0b'
        }}>
          <p style={{
            margin: 0,
            color: '#92400e',
            fontSize: '12px',
            textAlign: 'center',
            lineHeight: '1.4'
          }}>
            💡 <strong>How it works:</strong> This will open WhatsApp Web/App with your message pre-filled. 
            The message will be sent from your personal WhatsApp account to the parent's number.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WhatsAppMessenger;